'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

import { BlogCard } from '@eliadmin/core/src/components/blog/blog-card';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const BlogSwiper = ({ blogs }: { blogs: Blog[] }) => {
  return (
    <Swiper
      data-eli-component="homepage-blog-carousel"
      navigation={true}
      pagination={true}
      modules={[Navigation, Pagination]}
      className={cn('w-full min-w-0', 'mySwiper', 'ea-blog-swiper !pb-8 sm:!pb-0')}
      spaceBetween={12}
      slidesPerView={1}
      breakpoints={{
        1024: {
          spaceBetween: 24,
          slidesPerView: 'auto',
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 'auto',
        },
      }}
    >
      {blogs.map(blog => (
        <SwiperSlide key={blog.slug} className="w-full max-w-none md:max-w-[405px]">
          <BlogCard blog={blog} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
